export default "__VITE_ASSET__CrEYQKgo__"